import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelDynamic as _vModelDynamic, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ab0dad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "connect-code-view__container" }
const _hoisted_2 = { class: "connect-code" }
const _hoisted_3 = {
  key: 2,
  class: "connect-code__heading"
}
const _hoisted_4 = {
  key: 0,
  class: "connect-code__description dt-callout"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-callout__icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21.4 7.5C22.2 8.3 22.2 9.6 21.4 10.3L18.6 13.1L10.8 5.3L13.6 2.5C14.4 1.7 15.7 1.7 16.4 2.5L18.2 4.3L21.2 1.3L22.6 2.7L19.6 5.7L21.4 7.5M15.6 13.3L14.2 11.9L11.4 14.7L9.3 12.6L12.1 9.8L10.7 8.4L7.9 11.2L6.4 9.8L3.6 12.6C2.8 13.4 2.8 14.7 3.6 15.4L5.4 17.2L1.4 21.2L2.8 22.6L6.8 18.6L8.6 20.4C9.4 21.2 10.7 21.2 11.4 20.4L14.2 17.6L12.8 16.2L15.6 13.3Z" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We are unable to connect to this receiver. Make sure you're connected to the correct network and try again.", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "connect-code__heading"
}
const _hoisted_9 = {
  key: 1,
  class: "connect-code__description dt-callout"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-callout__icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "television-off"),
  /*#__PURE__*/_createElementVNode("path", { d: "M0.5,2.77L1.78,1.5L21,20.72L19.73,22L16.73,19H16V21H8V19H3A2,2 0 0,1 1,17V5C1,4.5 1.17,4.07 1.46,3.73L0.5,2.77M21,17V5H7.82L5.82,3H21A2,2 0 0,1 23,5V17C23,17.85 22.45,18.59 21.7,18.87L19.82,17H21M3,17H14.73L3,5.27V17Z" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No receivers for this room were found on your network. Please contact your IT administrator.", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "connect-code__description"
}
const _hoisted_14 = {
  for: "roomCodeInput",
  class: "connect-code__input-container"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "connect-code__checkmark",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "connect-code__no-results-icon",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12,0A12,12 0 0,1 24,12A12,12 0 0,1 12,24A12,12 0 0,1 0,12A12,12 0 0,1 12,0M12,2A10,10 0 0,0 2,12C2,14.4 2.85,16.6 4.26,18.33L18.33,4.26C16.6,2.85 14.4,2 12,2M12,22A10,10 0 0,0 22,12C22,9.6 21.15,7.4 19.74,5.67L5.67,19.74C7.4,21.15 9.6,22 12,22Z" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Select the receivers to connect to", -1))
const _hoisted_24 = { class: "receiver-select__table" }
const _hoisted_25 = { colspan: "2" }
const _hoisted_26 = { style: {"display":"flex"} }
const _hoisted_27 = { style: {"padding":"0.5rem 1rem"} }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onUpdate:modelValue", "value"]
const _hoisted_30 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_31 = {
  key: 0,
  class: "icon--large",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 0,
  class: "tooltiptext"
}
const _hoisted_35 = { class: "connect-code__buttons" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "connect-code__connect-button-text" }, "Connect", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "connect-code__heading" }, "Passcode needed", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "connect-code__description" }, "Enter the passcode on the receiver to share your screen.", -1))
const _hoisted_40 = {
  for: "passwordInput",
  class: "connect-code__input-container connect-code__input-container--prefix"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "connect-code__input-prefix" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" })
  ])
], -1))
const _hoisted_42 = { class: "connect-code__input-container-inner" }
const _hoisted_43 = ["type"]
const _hoisted_44 = { viewBox: "0 0 24 24" }
const _hoisted_45 = {
  key: 0,
  d: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
}
const _hoisted_46 = {
  key: 1,
  d: "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
}
const _hoisted_47 = { class: "connect-code__buttons" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "connect-code__connect-button-text" }, "Enter", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "connect-code__heading" }, "Connected!", -1))
const _hoisted_51 = { class: "dt-transition" }
const _hoisted_52 = { class: "connect-code__buttons" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "connect-code__connect-button-text" }, "Start Mirroring", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "connect-code__back-button-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z" })
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "connect-code__connect-button-text" }, "Disconnect", -1))
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "connect-code__heading" }, "Mirroring to", -1))
const _hoisted_59 = { class: "dt-transition" }
const _hoisted_60 = { class: "connect-code__buttons" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "connect-code__back-button-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z" })
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "connect-code__connect-button-text" }, "Disconnect", -1))
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wasm = _resolveComponent("wasm")!
  const _component_InlineTextLoader = _resolveComponent("InlineTextLoader")!
  const _component_Download = _resolveComponent("Download")!
  const _component_Sharing = _resolveComponent("Sharing")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_ctx.loadWasm)
        ? (_openBlock(), _createBlock(_component_wasm, {
            key: 0,
            onSenderStatusDidChange: _ctx.senderStatusDidChange,
            onSenderDidConnect: _ctx.senderDidConnect,
            onSenderConfigRetrievalFailed: _ctx.senderConfigRetrievalFailed,
            onSenderConfigRetrievalSucceeded: _ctx.senderConfigRetrievalSucceeded,
            onSenderDidDisconnect: _ctx.senderDidDisconnect,
            onSenderHasError: _ctx.senderHasError,
            onSenderNeedsPassword: _ctx.senderNeedsPassword,
            onSenderFailedAllQueries: _ctx.senderFailedAllQueries,
            onSenderReceiversListUpdated: _ctx.senderReceiversListUpdated
          }, null, 8, ["onSenderStatusDidChange", "onSenderDidConnect", "onSenderConfigRetrievalFailed", "onSenderConfigRetrievalSucceeded", "onSenderDidDisconnect", "onSenderHasError", "onSenderNeedsPassword", "onSenderFailedAllQueries", "onSenderReceiversListUpdated"]))
        : _createCommentVNode("", true),
      (_ctx.appState === 'Loading')
        ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
            key: 1,
            class: "connect-code__connect-loading-indicator"
          }))
        : (_ctx.appState === 'Error')
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Error!"))
          : (_ctx.appState === 'Suspended' || _ctx.appState === 'Ready' || (_ctx.appState === 'Connecting' && !_ctx.isPasswordRequired))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_ctx.didUserDisconnectUnepectedly)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_7))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.foundBranding)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_8, "Welcome!"))
                        : _createCommentVNode("", true),
                      (_ctx.failedAllQueries && (_ctx.failedAllQueriesID == _ctx.foundBranding.roomId))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "fade-up"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.organizationName)
                            ? (_openBlock(), _createElementBlock("h1", {
                                key: _ctx.organizationName,
                                class: "connect-code__heading dt-transition"
                              }, _toDisplayString(_ctx.organizationName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "fade-up"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.foundBranding)
                            ? (_openBlock(), _createElementBlock("h1", {
                                key: _ctx.foundBranding.bonjour,
                                class: "connect-code__heading dt-transition"
                              }, _toDisplayString(_ctx.foundBranding.bonjour), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (!_ctx.foundBranding)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, "To begin sharing your screen, enter the Ditto room code displayed in the room."))
                        : _createCommentVNode("", true),
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "fade-up"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.foundBranding)
                            ? (_openBlock(), _createElementBlock("p", {
                                class: "connect-code__description dt-transition",
                                key: _ctx.foundBranding.customMessage
                              }, _toDisplayString(_ctx.foundBranding.customMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 64)),
                _createElementVNode("form", {
                  autocomplete: "off",
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onConnectFormSubmit && _ctx.onConnectFormSubmit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      value: _ctx.address,
                      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lookupRoom($event, true))),
                      class: "connect-code__input",
                      id: "roomCodeInput",
                      spellcheck: "false",
                      placeholder: "Enter Room Code",
                      type: "text",
                      name: "hidden",
                      size: "1"
                    }, null, 40, _hoisted_15), [
                      [_directive_focus]
                    ]),
                    _createVNode(_Transition, {
                      mode: "out-in",
                      name: "fade-scale"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isRoomCodeBusy)
                          ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                              key: 0,
                              class: "connect-code__room-search-spinner"
                            }))
                          : (_ctx.isRoomFoundResponse === true && (_ctx.foundBranding.roomId != _ctx.failedAllQueriesID))
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                            : (_ctx.isRoomFoundResponse === false)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.roomReceivers.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", {
                          class: _normalizeClass(["receiver-select__container", {'receiver-select__container-fullwidth' : _ctx.isSmallScreen }])
                        }, [
                          _createElementVNode("table", _hoisted_24, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isSelectAllEnabled) = $event)),
                                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSelectAllReceivers($event)))
                                  }, null, 544), [
                                    [_vModelCheckbox, _ctx.isSelectAllEnabled]
                                  ]),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.receiverSelectAllText), 1)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomReceivers, (receiver) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: receiver.id
                              }, [
                                (!receiver.sspQueryFailed)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          "onUpdate:modelValue": ($event: any) => ((receiver.specificConnect) = $event),
                                          value: receiver,
                                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.receiverCheckChanged($event)))
                                        }, null, 40, _hoisted_29), [
                                          [_vModelCheckbox, receiver.specificConnect]
                                        ])
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(receiver.name), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("td", null, [
                                        (receiver.sspQueryFailed)
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(receiver.name), 1),
                                      (receiver.sspQueryFailed)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Unable to connect. This receiver was not found on your network. Contact your IT admin."))
                                        : _createCommentVNode("", true)
                                    ]))
                              ]))
                            }), 128))
                          ])
                        ], 2)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onConnectFormSubmit && _ctx.onConnectFormSubmit(...args))),
                      class: _normalizeClass(["dt-connect-button connect-code__connect-button", { 'connect-code__connect-button--is-connecting' : _ctx.appState == 'Connecting' || _ctx.isRoomLookupBusy }]),
                      disabled: _ctx.appState == 'Connecting' || (!_ctx.isAddressValid && _ctx.appState !== 'Suspended') || (!_ctx.address.length && _ctx.appState === 'Suspended') || !_ctx.isRoomFoundResponse,
                      type: "button"
                    }, [
                      _hoisted_37,
                      _createVNode(_Transition, { name: "fade-scale" }, {
                        default: _withCtx(() => [
                          (_ctx.appState == 'Connecting' || _ctx.isRoomLookupBusy)
                            ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                key: 0,
                                class: "connect-code__connect-button-indicator"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 10, _hoisted_36)
                  ])
                ], 32)
              ], 64))
            : (_ctx.appState === 'NeedsPassword' || (_ctx.appState === 'Connecting' && _ctx.isPasswordRequired))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 4,
                  autocomplete: "off",
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)), ["prevent"])),
                  id: "passwordForm"
                }, [
                  _hoisted_38,
                  _hoisted_39,
                  _createElementVNode("label", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        class: "connect-code__input",
                        type: _ctx.isPasswordInputVisible ? 'text' : 'password',
                        id: "passwordInput",
                        ref: "passwordInput",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordInput) = $event)),
                        placeholder: "Enter passcode",
                        size: "1"
                      }, null, 8, _hoisted_43), [
                        [_directive_focus],
                        [_vModelDynamic, _ctx.passwordInput]
                      ]),
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "fade-scale"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.appState == 'Connecting')
                            ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                key: 0,
                                class: "connect-code__password-spinner"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        class: "connect-code__input-button",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleIsPasswordInputVisible && _ctx.toggleIsPasswordInputVisible(...args))),
                        type: "button"
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_44, [
                          (_ctx.isPasswordInputVisible)
                            ? (_openBlock(), _createElementBlock("path", _hoisted_45))
                            : (_openBlock(), _createElementBlock("path", _hoisted_46))
                        ]))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["dt-connect-button connect-code__connect-button", { 'connect-code__connect-button--is-connecting' : _ctx.appState == 'Connecting' }]),
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args))),
                      disabled: _ctx.appState != 'NeedsPassword' || !_ctx.passwordInput.length
                    }, [
                      _hoisted_49,
                      _createVNode(_Transition, { name: "fade-scale" }, {
                        default: _withCtx(() => [
                          (_ctx.appState == 'Connecting')
                            ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                key: 0,
                                class: "connect-code__connect-button-indicator"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 10, _hoisted_48)
                  ])
                ], 32))
              : (_ctx.appState === 'Connected')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _hoisted_50,
                    _createVNode(_Transition, {
                      mode: "out-in",
                      name: "fade-up"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(), _createElementBlock("h1", {
                            key: _ctx.foundRoomName,
                            class: "connect-code__found-room-name dt-transition"
                          }, _toDisplayString(_ctx.foundRoomName), 1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiverName, (name) => {
                            return (_openBlock(), _createElementBlock("ul", {
                              class: "no-bullets",
                              key: name
                            }, [
                              _createElementVNode("li", null, [
                                (_openBlock(), _createElementBlock("h2", {
                                  key: name,
                                  class: "connect-code__found-room-name dt-transition"
                                }, _toDisplayString(name), 1))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("button", {
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startMirroring && _ctx.startMirroring(...args))),
                        class: "dt-connect-button",
                        type: "button"
                      }, _hoisted_54),
                      _createElementVNode("button", {
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args))),
                        class: "dt-connect-button dt-connect-button--secondary",
                        type: "button"
                      }, _hoisted_57)
                    ])
                  ], 64))
                : (_ctx.appState === 'Mirroring')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _hoisted_58,
                      _createVNode(_Transition, {
                        mode: "out-in",
                        name: "fade-up"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_59, [
                            (_openBlock(), _createElementBlock("h1", {
                              key: _ctx.foundRoomName,
                              class: "connect-code__found-room-name dt-transition"
                            }, _toDisplayString(_ctx.foundRoomName), 1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiverName, (name) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                class: "no-bullets",
                                key: name
                              }, [
                                _createElementVNode("li", null, [
                                  (_openBlock(), _createElementBlock("h2", {
                                    key: name,
                                    class: "connect-code__found-room-name dt-transition"
                                  }, _toDisplayString(name), 1))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", {
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.stopMirroring && _ctx.stopMirroring(...args))),
                          class: "dt-connect-button",
                          type: "button"
                        }, "Stop Mirroring"),
                        _createElementVNode("button", {
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args))),
                          class: "dt-connect-button dt-connect-button--secondary",
                          type: "button"
                        }, _hoisted_63)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.isRoomCodeView]
    ]),
    (_ctx.isDownloadView)
      ? (_openBlock(), _createBlock(_component_Download, {
          key: 0,
          userAgent: _ctx.userAgent,
          roomConfig: _ctx.foundBranding
        }, null, 8, ["userAgent", "roomConfig"]))
      : (_ctx.isSharingView)
        ? (_openBlock(), _createBlock(_component_Sharing, {
            key: 1,
            isSupportedBrowser: _ctx.isSupportedBrowser,
            loadWasm: _ctx.loadWasm,
            isSSPReceiver: _ctx.isSSPReceiver,
            onContinueOnBrowser: _ctx.continueOnBrowserHandler,
            onContinueToDownload: _ctx.continueToDownloadHandler
          }, null, 8, ["isSupportedBrowser", "loadWasm", "isSSPReceiver", "onContinueOnBrowser", "onContinueToDownload"]))
        : _createCommentVNode("", true)
  ]))
}